import * as _DashboardRoutes from './Dashboard';
import * as _DemographicsRoutes from './Demographics';
import * as _ForgotPasswordRoutes from './ForgotPassword';
import * as _FulfillmentCentersRoutes from './FulfillmentCenters';
import * as _MenuRoutes from './Menu';
import * as _OnboardingRoutes from './Onboarding';
import * as _UserRoutes from './Users';

import * as _ReportRoutes from './Reports';
import * as _OrderRoutes from './Order';
import * as _FulfillmentCenterDeliveryManagementRoutes from './FulfillmentCenterDeliveryManagement';
import * as _VenueManageRoutes from './Venues';

export { Home } from './Home';
export { Login } from './Login';
export { Health as HealthRoute } from './Health';
export { SquareCallback } from './SquareCallback';
export const DashboardRoutes = _DashboardRoutes;
export const DemographicsRoutes = _DemographicsRoutes;
export const ForgotPasswordRoutes = _ForgotPasswordRoutes;
export const FulfillmentCentersRoutes = _FulfillmentCentersRoutes;
export const MenuRoutes = _MenuRoutes;
export const OnboardingRoutes = _OnboardingRoutes;
export const ReportRoutes = _ReportRoutes;
export const UserRoutes = _UserRoutes;
export const VenueManageRoutes = _VenueManageRoutes;
export const FulfillmentCenterDeliveryManagementRoutes = _FulfillmentCenterDeliveryManagementRoutes;
export const OrderRoutes = _OrderRoutes;
